module.exports = __webpack_public_path__ + "img/watch.c7c7f8cf.jpg";